import React, { useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PageHeader from '../../components/PageHeader/PageHeader';
import { Tabs, Tab } from '../../components/Tabs/Tabs';
import Modal from '../../components/Modal/Modal';
import FilterCard from '../../components/FilterCard/FilterCard';
import { BsSearch } from 'react-icons/bs';
import { BsArrowUp, BsArrowDown, BsArrowRight, BsInboxFill, BsChevronUp, BsChevronDown } from 'react-icons/bs';
import { MdStackedBarChart } from 'react-icons/md';
import { HiOutlineChartBar, HiOutlineChartPie } from 'react-icons/hi';
import './HedeflerKarsilastir.css';
import DataTable from '../../components/DataTable/DataTable';
import Select from '../../components/Select/Select';

const NoDataFound = () => (
  <div className="no-data-found">
    <BsInboxFill className="no-data-icon" />
    <h3 className="no-data-title">Gösterilecek Veri Bulunamadı</h3>
    <p className="no-data-text">
      Arama kriterlerinize uygun veri bulunmamaktadır. Lütfen filtrelerinizi değiştirerek tekrar deneyin.
    </p>
  </div>
);

const HedeflerKarsilastir = () => {
  useEffect(() => {
    const loadTreeMap = async () => {
      try {
        const TreeMap = await import('highcharts/modules/treemap');
        if (typeof TreeMap === 'function') {
          TreeMap(Highcharts);
        } else if (typeof TreeMap.default === 'function') {
          TreeMap.default(Highcharts);
        } else {
          console.warn('TreeMap module loaded but initialization function not found');
        }
      } catch (error) {
        console.error('Error loading TreeMap module:', error);
      }
    };
    loadTreeMap();
  }, []);

  const [activeTab, setActiveTab] = useState('birim-makale');
  const [searchTerm, setSearchTerm] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [heatmapModalOpen, setHeatmapModalOpen] = useState(false);
  const [activeHeatmapType, setActiveHeatmapType] = useState('mr');
  const [selectedBolum, setSelectedBolum] = useState(null);
  const [selectedAkademisyen, setSelectedAkademisyen] = useState(null);
  const [selectedFaculties, setSelectedFaculties] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [expandedDept, setExpandedDept] = useState(null);

  const facultyOptions = [
    { value: 'all', label: 'Tüm Fakülteler' },
    { value: 'muhendislik', label: 'Mühendislik Fakültesi' },
    { value: 'mimarlik', label: 'Mimarlık Fakültesi' },
    { value: 'fen', label: 'Fen Fakültesi' }
  ];

  const departmentOptions = [
    { value: 'all', label: 'Tüm Bölümler' },
    { value: 'endustri', label: 'Endüstri Mühendisliği' },
    { value: 'bilgisayar', label: 'Bilgisayar Mühendisliği' },
    { value: 'makine', label: 'Makine Mühendisliği' },
    { value: 'mimarlik', label: 'Mimarlık' },
    { value: 'sehir', label: 'Şehir ve Bölge Planlama' },
    { value: 'fizik', label: 'Fizik Mühendisliği' }
  ];

  const handleFacultyChange = (selectedOptions) => {
    setSelectedFaculties(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedFaculties([{ value: 'all', label: 'Tüm Fakülteler' }]);
    }
  };

  const handleDepartmentChange = (selectedOptions) => {
    setSelectedDepartments(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedDepartments([{ value: 'all', label: 'Tüm Bölümler' }]);
    }
  };

  const birimMakaleData = [
    {
      name: "Endüstri Mühendisliği",
      mrData: {
        title: "Üye Başına Makale",
        data: [
          { donem: "2022", hedef: 2, gerceklesen: 3, not: "Hedef aşıldı" },
          { donem: "2023", hedef: 3, gerceklesen: 2, not: "Hedefin altında" },
          { donem: "2024", hedef: 4, gerceklesen: 5, not: "Başarılı" },
          { donem: "2025", hedef: 5, gerceklesen: "Girilmedi", not: "Henüz veri girilmedi" }
        ]
      },
      q1q2Data: {
        title: "Q1 + Q2 Yüzdesi",
        data: [
          { donem: "2022", hedef: 75, gerceklesen: 80, not: "Hedef aşıldı" },
          { donem: "2023", hedef: 80, gerceklesen: 85, not: "Başarılı" },
          { donem: "2024", hedef: 85, gerceklesen: 90, not: "Çok başarılı" },
          { donem: "2025", hedef: 90, gerceklesen: "Girilmedi", not: "Henüz veri girilmedi" }
        ]
      }
    },
    {
      name: "Bilgisayar Mühendisliği",
      mrData: {
        title: "Üye Başına Makale",
        data: [
          { donem: "2022", hedef: 3, gerceklesen: 4, not: "Hedef aşıldı" },
          { donem: "2023", hedef: 4, gerceklesen: 5, not: "Başarılı" },
          { donem: "2024", hedef: 5, gerceklesen: 6, not: "Çok başarılı" },
          { donem: "2025", hedef: 6, gerceklesen: "Girilmedi", not: "Henüz veri girilmedi" }
        ]
      },
      q1q2Data: {
        title: "Q1 + Q2 Yüzdesi",
        data: [
          { donem: "2022", hedef: 80, gerceklesen: 85, not: "Hedef aşıldı" },
          { donem: "2023", hedef: 85, gerceklesen: 90, not: "Başarılı" },
          { donem: "2024", hedef: 90, gerceklesen: 95, not: "Çok başarılı" },
          { donem: "2025", hedef: 95, gerceklesen: "Girilmedi", not: "Henüz veri girilmedi" }
        ]
      }
    },
    {
      name: "Makine Mühendisliği",
      mrData: {
        title: "Üye Başına Makale",
        data: [
          { donem: "2022", hedef: 2, gerceklesen: 3, not: "Hedef aşıldı" },
          { donem: "2023", hedef: 3, gerceklesen: 4, not: "Başarılı" },
          { donem: "2024", hedef: 4, gerceklesen: 3, not: "Hedefin altında" },
          { donem: "2025", hedef: 5, gerceklesen: "Girilmedi", not: "Henüz veri girilmedi" }
        ]
      },
      q1q2Data: {
        title: "Q1 + Q2 Yüzdesi",
        data: [
          { donem: "2022", hedef: 70, gerceklesen: 75, not: "Hedef aşıldı" },
          { donem: "2023", hedef: 75, gerceklesen: 80, not: "Başarılı" },
          { donem: "2024", hedef: 80, gerceklesen: 75, not: "Hedefin altında" },
          { donem: "2025", hedef: 85, gerceklesen: "Girilmedi", not: "Henüz veri girilmedi" }
        ]
      }
    }
  ];

  const birimProjeData = [
    {
      name: "Endüstri Mühendisliği",
      projeData: {
        title: "Proje Sayısı",
        data: [
          { donem: "2022", hedef: 3, gerceklesen: 4, not: "Hedef aşıldı" },
          { donem: "2023", hedef: 4, gerceklesen: 3, not: "Hedefin altında" },
          { donem: "2024", hedef: 5, gerceklesen: 6, not: "Başarılı" },
          { donem: "2025", hedef: 6, gerceklesen: "Girilmedi", not: "Henüz veri girilmedi" }
        ]
      },
      butceData: {
        title: "Proje Bütçesi (₺)",
        data: [
          { donem: "2022", hedef: 500000, gerceklesen: 750000, not: "Hedef aşıldı" },
          { donem: "2023", hedef: 750000, gerceklesen: 600000, not: "Hedefin altında" },
          { donem: "2024", hedef: 1000000, gerceklesen: 1200000, not: "Başarılı" },
          { donem: "2025", hedef: 1500000, gerceklesen: "Girilmedi", not: "Henüz veri girilmedi" }
        ]
      }
    }
  ];

  const akademisyenMakaleData = {
    bolumler: [
      {
        id: 1,
        bolumAdi: "Bilişim Enstitüsü",
        toplamAkademisyen: 12,
        toplamMakale: 45,
        ortalamaQ1Q2: 85.5,
        mrOrtalama: 2.4,
        performansOzeti: "2024 hedeflerinin %80'i tamamlandı",
        akademisyenler: [
          {
            id: 1,
            name: "Prof. Dr. Adnan Midilli",
            unvan: "Prof. Dr.",
            performansOzeti: "2024 hedefinin %75'i tamamlandı",
            mrData: {
              title: "M-R Sayısı",
              data: [
                { donem: "2022", hedef: 5, gerceklesen: 3, not: "2 adet Q1" },
                { donem: "2023", hedef: 13, gerceklesen: 8, not: "3 adet Q1" },
                { donem: "2024", hedef: 6, gerceklesen: 7, not: "2 adet Q1, devam ediyor" },
                { donem: "2025", hedef: 5, gerceklesen: "Henüz Girilmedi", not: "Henüz veri girilmedi" }
              ]
            }
          },
          {
            id: 2,
            name: "Prof. Dr. Alper Ünal",
            unvan: "Prof. Dr.",
            performansOzeti: "2024 hedefinin %60'ı tamamlandı",
            mrData: {
              title: "M-R Sayısı",
              data: [
                { donem: "2022", hedef: 5, gerceklesen: 3, not: "2 adet Q1" },
                { donem: "2023", hedef: 0, gerceklesen: 2, not: "1 adet Q1" },
                { donem: "2024", hedef: 6, gerceklesen: 1, not: "2 adet Q1, devam ediyor" },
                { donem: "2025", hedef: "Girilmedi", gerceklesen: "Henüz Girilmedi", not: "Henüz veri girilmedi" }
              ]
            }
          },
          {
            id: 3,
            name: "Prof. Dr. Ali Mohammadi",
            unvan: "Prof. Dr.",
            performansOzeti: "2024 hedefinin %85'i tamamlandı",
            mrData: {
              title: "M-R Sayısı",
              data: [
                { donem: "2022", hedef: 5, gerceklesen: 3, not: "3 adet Q1" },
                { donem: "2023", hedef: 13, gerceklesen: 8, not: "5 adet Q1" },
                { donem: "2024", hedef: 6, gerceklesen: 7, not: "4 adet Q1, devam ediyor" },
                { donem: "2025", hedef: 3, gerceklesen: "Henüz Girilmedi", not: "Henüz veri girilmedi" }
              ]
            }
          }
        ]
      },
      {
        id: 2,
        bolumAdi: "Enerji Enstitüsü",
        toplamAkademisyen: 8,
        toplamMakale: 32,
        ortalamaQ1Q2: 78.3,
        mrOrtalama: 2.1,
        performansOzeti: "2024 hedeflerinin %65'i tamamlandı",
        akademisyenler: [
          {
            id: 4,
            name: "Prof. Dr. Ahmet Durmayaz",
            unvan: "Prof. Dr.",
            performansOzeti: "2024 hedefinin %70'i tamamlandı",
            mrData: {
              title: "M-R Sayısı",
              data: [
                { donem: "2022", hedef: 2, gerceklesen: 3, not: "2 adet Q1 veya Q2" },
                { donem: "2023", hedef: 3, gerceklesen: 1, not: "1 adet Q1" },
                { donem: "2024", hedef: 2, gerceklesen: 1, not: "2 adet Q1 veya Q2" }
              ]
            }
          },
          {
            id: 5,
            name: "Prof. Dr. Mehmet Yılmaz",
            unvan: "Prof. Dr.",
            performansOzeti: "2024 hedefinin %55'i tamamlandı",
            mrData: {
              title: "M-R Sayısı",
              data: [
                { donem: "2022", hedef: 3, gerceklesen: 2, not: "1 adet Q1" },
                { donem: "2023", hedef: 4, gerceklesen: 3, not: "2 adet Q1" },
                { donem: "2024", hedef: 5, gerceklesen: 2, not: "1 adet Q1, devam ediyor" }
              ]
            }
          }
        ]
      }
    ]
  };

  const akademisyenProjeData = {
    bolumler: [
      {
        id: 1,
        bolumAdi: "Bilişim Enstitüsü",
        toplamAkademisyen: 12,
        toplamProje: 18,
        toplamButce: "2.5M ₺",
        projeOrtalama: 1.5,
        performansOzeti: "2024 hedeflerinin %70'i tamamlandı"
      },
      {
        id: 2,
        bolumAdi: "Enerji Enstitüsü",
        toplamAkademisyen: 8,
        toplamProje: 12,
        toplamButce: "1.8M ₺",
        projeOrtalama: 1.2,
        performansOzeti: "2024 hedeflerinin %60'ı tamamlandı"
      }
    ],
    bolumDetaylari: {
      1: {
        bolumOzeti: {
          title: "Bilişim Enstitüsü Proje Performans Özeti",
          data: [
            { donem: "2022", hedef: 15, gerceklesen: 16, not: "Hedef aşıldı" },
            { donem: "2023", hedef: 16, gerceklesen: 14, not: "Hedefin altında" },
            { donem: "2024", hedef: 18, gerceklesen: 15, not: "Devam ediyor" }
          ]
        },
        akademisyenler: [
          {
            id: 1,
            name: "Prof. Dr. Adnan Midilli",
            unvan: "Prof. Dr.",
            performansOzeti: "2024 hedefinin %80'i tamamlandı",
            projeData: {
              title: "Proje Sayısı",
              data: [
                { donem: "2022", hedef: 2, gerceklesen: 3, not: "1 TÜBİTAK, 2 BAP" },
                { donem: "2023", hedef: 3, gerceklesen: 2, not: "2 TÜBİTAK" },
                { donem: "2024", hedef: 3, gerceklesen: 2, not: "1 TÜBİTAK, 1 BAP" }
              ]
            },
            projeler: [
              {
                baslik: "Yapay Zeka Destekli Enerji Optimizasyonu",
                tur: "TÜBİTAK",
                yil: 2024,
                butce: "750.000 ₺",
                durum: "Devam Ediyor",
                rol: "Yürütücü"
              },
              {
                baslik: "Akıllı Şehir Sistemleri",
                tur: "BAP",
                yil: 2023,
                butce: "150.000 ₺",
                durum: "Tamamlandı",
                rol: "Yürütücü"
              }
            ]
          }
        ]
      },
      2: {
        bolumOzeti: {
          title: "Enerji Enstitüsü Proje Performans Özeti",
          data: [
            { donem: "2022", hedef: 10, gerceklesen: 8, not: "Hedefin altında" },
            { donem: "2023", hedef: 12, gerceklesen: 14, not: "Hedef aşıldı" },
            { donem: "2024", hedef: 15, gerceklesen: 12, not: "Devam ediyor" }
          ]
        },
        akademisyenler: [
          {
            id: 1,
            name: "Prof. Dr. Ahmet Durmayaz",
            unvan: "Prof. Dr.",
            performansOzeti: "2024 hedefinin %65'i tamamlandı",
            projeData: {
              title: "Proje Sayısı",
              data: [
                { donem: "2022", hedef: 2, gerceklesen: 1, not: "1 AB Projesi" },
                { donem: "2023", hedef: 2, gerceklesen: 3, not: "1 TÜBİTAK, 2 BAP" },
                { donem: "2024", hedef: 3, gerceklesen: 2, not: "2 TÜBİTAK" }
              ]
            },
            projeler: [
              {
                baslik: "Yenilenebilir Enerji Sistemleri",
                tur: "TÜBİTAK",
                yil: 2024,
                butce: "950.000 ₺",
                durum: "Devam Ediyor",
                rol: "Yürütücü"
              }
            ]
          }
        ]
      }
    }
  };

  const getChartOptions = (title, data, maxY = 5) => ({
    chart: {
      type: 'column',
      height: 350,
      style: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }
    },
    title: {
      text: title,
      style: { 
        fontSize: '14px',
        fontWeight: '500'
      }
    },
    xAxis: {
      categories: ['2022', '2023', '2024', '2025', '2026', '2027', '2028'],
      labels: {
        style: {
          fontSize: '12px'
        }
      }
    },
    yAxis: {
      title: { text: null },
      max: maxY,
      tickInterval: title.includes('Q1 + Q2') ? 10 : 0.5,
      labels: {
        style: {
          fontSize: '12px'
        }
      },
      gridLineWidth: 1,
      gridLineColor: '#f0f0f0'
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: {
        fontSize: '12px'
      }
    },
    series: [{
      name: 'Hedef',
      data: data.map(d => d.hedef),
      color: '#4285f4'
    }, {
      name: 'Gerçekleşen',
      data: data.map(d => d.gerceklesen === 'Girilmedi' ? null : d.gerceklesen),
      color: '#34a853'
    }],
    credits: { enabled: false },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        borderRadius: 4
      }
    },
    tooltip: {
      shared: true,
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderWidth: 0,
      borderRadius: 8,
      shadow: true,
      style: {
        fontSize: '12px'
      },
      useHTML: true,
      formatter: function() {
        let s = '<div style="padding: 5px;"><b>' + this.x + '</b><br/>';
        this.points.forEach(function(point) {
          s += '<div style="display: flex; align-items: center; gap: 5px; margin: 3px 0;">' +
               '<div style="width: 10px; height: 10px; background-color: ' + point.color + '; border-radius: 50%;"></div>' +
               '<span>' + point.series.name + ': ' + point.y + (title.includes('Q1 + Q2') ? '%' : '') + '</span>' +
               '</div>';
        });
        return s + '</div>';
      }
    }
  });

  const getTrendIcon = (current, previous) => {
    if (!previous || current === 'Girilmedi' || previous === 'Girilmedi') return null;
    const currentValue = parseFloat(current);
    const previousValue = parseFloat(previous);
    
    if (currentValue > previousValue) {
      return <BsArrowUp className="text-success ms-1" />;
    } else if (currentValue < previousValue) {
      return <BsArrowDown className="text-danger ms-1" />;
    }
    return <BsArrowRight className="text-warning ms-1" />;
  };

  const handleNoteClick = (note) => {
    setSelectedNote(note);
    setModalOpen(true);
  };

  const handleBolumDetay = (bolumId) => {
    if (activeTab === 'akademisyen-makale') {
      const bolumDetay = akademisyenMakaleData.bolumler.find(b => b.id === bolumId);
      if (bolumDetay) {
        const bolumOzetiData = {
          title: `${bolumDetay.bolumAdi} Performans Özeti`,
          data: bolumDetay.akademisyenler.reduce((acc, akademisyen) => {
            return acc.concat(akademisyen.mrData.data);
          }, [])
        };

        setSelectedBolum({
          ...bolumDetay,
          bolumOzeti: bolumOzetiData
        });
        setSelectedAkademisyen(null);
      }
    } else if (activeTab === 'akademisyen-proje') {
      const bolumDetay = akademisyenProjeData.bolumDetaylari[bolumId];
      if (bolumDetay) {
        setSelectedBolum({
          ...bolumDetay,
          bolumAdi: akademisyenProjeData.bolumler.find(b => b.id === bolumId)?.bolumAdi,
          akademisyenler: bolumDetay.akademisyenler,
          bolumOzeti: bolumDetay.bolumOzeti
        });
        setSelectedAkademisyen(null);
      }
    }
  };

  const handleAkademisyenDetay = (akademisyen) => {
    // window.location.href = `/akademisyen-detay/${akademisyen.id}`;
    window.location.href = `/akademisyen-detay/1`;
  };

  const handleBack = () => {
    if (selectedAkademisyen) {
      setSelectedAkademisyen(null);
    } else if (selectedBolum) {
      setSelectedBolum(null);
    }
  };

  const getFilteredData = (data, type) => {
    let filteredData = [...data];

    if (selectedFaculties.length > 0 && !selectedFaculties.some(f => f.value === 'all')) {
      filteredData = filteredData.filter(item => {
        const faculty = getFacultyFromDepartment(item.name);
        return selectedFaculties.some(f => f.value === faculty);
      });
    }

    if (selectedDepartments.length > 0 && !selectedDepartments.some(d => d.value === 'all')) {
      filteredData = filteredData.filter(item =>
        selectedDepartments.some(d => d.label === item.name)
      );
    }

    if (searchTerm) {
      filteredData = filteredData.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    return filteredData;
  };

  const getFacultyFromDepartment = (departmentName) => {
    const facultyMap = {
      'Endüstri Mühendisliği': 'muhendislik',
      'Bilgisayar Mühendisliği': 'muhendislik',
      'Makine Mühendisliği': 'muhendislik',
      'Mimarlık': 'mimarlik',
      'Şehir ve Bölge Planlama': 'mimarlik',
      'Fizik Mühendisliği': 'fen'
    };
    return facultyMap[departmentName] || 'other';
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'birim-makale':
        const filteredBirimMakaleData = getFilteredData(birimMakaleData, 'makale');
        if (filteredBirimMakaleData.length === 0) {
          return <NoDataFound />;
        }
        return (
          <>
            {filteredBirimMakaleData.map((dept, index) => (
              <div className="department-card" key={index}>
                <div 
                  className={`card-header ${expandedDept === dept.name ? 'expanded' : ''}`}
                  onClick={() => setExpandedDept(expandedDept === dept.name ? null : dept.name)}
                >
                  <h6 className="card-title d-flex justify-content-between align-items-center">
                    {dept.name}
                    <span className="expand-icon">
                      {expandedDept === dept.name ? <BsChevronUp /> : <BsChevronDown />}
                    </span>
                  </h6>
                </div>
                {expandedDept === dept.name && (
                  <div className="card-body">
                    <div className="item mb-4">
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <h6 className="unit-title">{dept.mrData.title}</h6>
                          <DataTable 
                            data={dept.mrData.data}
                            onNoteClick={handleNoteClick}
                          />
                          <div className="chart-container">
                            <HighchartsReact 
                              highcharts={Highcharts} 
                              options={getChartOptions("Üye Başına Makale", dept.mrData.data)} 
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <h6 className="section-title">{dept.q1q2Data.title}</h6>
                          <DataTable 
                            data={dept.q1q2Data.data}
                            onNoteClick={handleNoteClick}
                          />
                          <div className="chart-container">
                            <HighchartsReact 
                              highcharts={Highcharts} 
                              options={getChartOptions("Q1 + Q2 Yüzdesi", dept.q1q2Data.data, 100)} 
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        );

      case 'birim-proje':
        const filteredBirimProjeData = getFilteredData(birimProjeData, 'proje');
        if (filteredBirimProjeData.length === 0) {
          return <NoDataFound />;
        }
        return (
          <>
            {filteredBirimProjeData.map((dept, index) => (
              <div className="department-card" key={index}>
                <div 
                  className={`card-header ${expandedDept === dept.name ? 'expanded' : ''}`}
                  onClick={() => setExpandedDept(expandedDept === dept.name ? null : dept.name)}
                >
                  <h5 className="card-title d-flex justify-content-between align-items-center">
                    {dept.name}
                    <span className="expand-icon">
                      {expandedDept === dept.name ? <BsChevronUp /> : <BsChevronDown />}
                    </span>
                  </h5>
                </div>
                {expandedDept === dept.name && (
                  <div className="card-body">
                    <div className="mb-4">
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <h6 className="section-title">{dept.projeData.title}</h6>
                          <DataTable 
                            data={dept.projeData.data}
                            onNoteClick={handleNoteClick}
                          />
                        </div>
                        <div className="col-md-6">
                          <div className="chart-container">
                            <HighchartsReact 
                              highcharts={Highcharts} 
                              options={getChartOptions("Proje Sayısı", dept.projeData.data)} 
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <h6 className="section-title">{dept.butceData.title}</h6>
                          <DataTable 
                            data={dept.butceData.data}
                            onNoteClick={handleNoteClick}
                          />
                        </div>
                        <div className="col-md-6">
                          <div className="chart-container">
                            <HighchartsReact 
                              highcharts={Highcharts} 
                              options={getChartOptions("Proje Bütçesi", dept.butceData.data)} 
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        );

      case 'akademisyen-makale':
        if (selectedAkademisyen) {
          return (
            <div className="department-card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                  <button className="btn btn-link text-primary p-0 me-3" onClick={handleBack}>
                    <i className="fas fa-arrow-left"></i> Geri
                  </button>
                  <h5 className="card-title d-inline-block mb-0">{selectedAkademisyen.name}</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="akademisyen-profil mb-4">
                  <div className="d-flex align-items-center">
                    <div className="avatar me-4">
                      <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" 
                           style={{width: '64px', height: '64px', fontSize: '24px'}}>
                        {selectedAkademisyen.name.charAt(0)}
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-1">{selectedAkademisyen.name}</h5>
                      <p className="text-muted mb-2">{selectedAkademisyen.unvan}</p>
                      <div className="badge bg-success-subtle text-success">
                        {selectedAkademisyen.performansOzeti}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <h6 className="section-title">{selectedAkademisyen.mrData.title}</h6>
                    <DataTable 
                      data={selectedAkademisyen.mrData.data}
                      onNoteClick={handleNoteClick}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="chart-container">
                      <HighchartsReact 
                        highcharts={Highcharts} 
                        options={getChartOptions("M-R Performans Trendi", selectedAkademisyen.mrData.data)} 
                      />
                    </div>
                  </div>
                </div>

                <div className="makale-listesi">
                  <h6 className="section-title mb-3">Makaleler</h6>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Başlık</th>
                          <th>Dergi</th>
                          <th>Yıl</th>
                          <th>Q</th>
                          <th>DOI</th>
                          <th>Atıf</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedAkademisyen.makaleler.map((makale, index) => (
                          <tr key={index}>
                            <td>{makale.baslik}</td>
                            <td>{makale.dergi}</td>
                            <td>{makale.yil}</td>
                            <td>
                              <span className={`badge bg-${makale.q === 'Q1' ? 'success' : 'primary'}-subtle text-${makale.q === 'Q1' ? 'success' : 'primary'}`}>
                                {makale.q}
                              </span>
                            </td>
                            <td>
                            </td>
                            <td>{makale.atif}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        if (selectedBolum) {
          return (
            <div className="department-card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                  <button className="btn btn-link text-primary p-0 me-3" onClick={handleBack}>
                    <i className="fas fa-arrow-left"></i> Geri
                  </button>
                  <h5 className="card-title d-inline-block mb-0">{selectedBolum.bolumOzeti.title}</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h6 className="section-title mb-4">Akademisyenler</h6>
                    <div className="akademisyen-list">
                      {selectedBolum.akademisyenler.map((akademisyen) => (
                        <div key={akademisyen.id} className="akademisyen-card" onClick={() => handleAkademisyenDetay(akademisyen)}>
                          <div className="akademisyen-info">
                            <div className="akademisyen-avatar">
                              {akademisyen.name.charAt(0)}
                            </div>
                            <div>
                              <h6 className="akademisyen-name">{akademisyen.name}</h6>
                              <p className="akademisyen-title">{akademisyen.unvan}</p>
                            </div>
                          </div>
                          <div className="performance-summary">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="text-muted">Performans</span>
                              <span className="badge bg-success-subtle text-success">
                                {akademisyen.performansOzeti}
                              </span>
                            </div>
                            <div className="progress" style={{height: '6px'}}>
                              <div 
                                className="progress-bar bg-success" 
                                style={{width: akademisyen.performansOzeti.replace(/[^0-9]/g, '') + '%'}}
                              ></div>
                            </div>
                          </div>
                          <div className="mini-chart-container mt-3">
                            <HighchartsReact 
                              highcharts={Highcharts} 
                              options={getMiniChartOptions(akademisyen.mrData.data)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="col-md-6">
                    <h6 className="section-title mb-4">Performans Özeti</h6>
                    <div className="chart-container">
                      <HighchartsReact 
                        highcharts={Highcharts} 
                        options={getChartOptions("Bölüm Performans Trendi", selectedBolum.bolumOzeti.data)} 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        let filteredBolumler = [...akademisyenMakaleData.bolumler];
        if (selectedFaculties.length > 0 && !selectedFaculties.some(f => f.value === 'all')) {
          filteredBolumler = filteredBolumler.filter(bolum => {
            const faculty = getFacultyFromDepartment(bolum.bolumAdi);
            return selectedFaculties.some(f => f.value === faculty);
          });
        }
        if (selectedDepartments.length > 0 && !selectedDepartments.some(d => d.value === 'all')) {
          filteredBolumler = filteredBolumler.filter(bolum =>
            selectedDepartments.some(d => d.label === bolum.bolumAdi)
          );
        }
        if (searchTerm) {
          filteredBolumler = filteredBolumler.filter(bolum =>
            bolum.bolumAdi.toLowerCase().includes(searchTerm.toLowerCase())
          );
        }

        if (filteredBolumler.length === 0) {
          return <NoDataFound />;
        }

        return (
          <div className="department-card">
            <div className="card-header">
              <h5 className="card-title">Akademik Bölümler</h5>
            </div>
            <div className="card-body">
              <div className="row g-4">
                {filteredBolumler.map((bolum) => (
                  <div key={bolum.id} className="col-md-6">
                    <div className="bolum-card p-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="bolum-title mb-0">{bolum.bolumAdi}</h6>
                        <span className="badge bg-primary-subtle text-primary">
                          {bolum.performansOzeti}
                        </span>
                      </div>
                      
                      <div className="stats-grid">
                        <div className="stat-item">
                          <div className="stat-label">Akademisyen</div>
                          <div className="stat-value">{bolum.toplamAkademisyen}</div>
                        </div>
                        <div className="stat-item">
                          <div className="stat-label">Makale</div>
                          <div className="stat-value">{bolum.toplamMakale}</div>
                        </div>
                        <div className="stat-item">
                          <div className="stat-label">Q1+Q2</div>
                          <div className="stat-value">%{bolum.ortalamaQ1Q2}</div>
                        </div>
                        <div className="stat-item">
                          <div className="stat-label">M-R Ort.</div>
                          <div className="stat-value">{bolum.mrOrtalama}</div>
                        </div>
                      </div>

                      <button 
                        className="btn-detail"
                        onClick={() => handleBolumDetay(bolum.id)}
                      >
                        Detayları Görüntüle
                        <i className="fas fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      case 'akademisyen-proje':
        if (selectedAkademisyen) {
          return (
            <div className="department-card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                  <button className="btn btn-link text-primary p-0 me-3" onClick={handleBack}>
                    <i className="fas fa-arrow-left"></i> Geri
                  </button>
                  <h5 className="card-title d-inline-block mb-0">{selectedAkademisyen.name}</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="akademisyen-profil mb-4">
                  <div className="d-flex align-items-center">
                    <div className="avatar me-4">
                      <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" 
                           style={{width: '64px', height: '64px', fontSize: '24px'}}>
                        {selectedAkademisyen.name.charAt(0)}
                      </div>
                    </div>
                    <div>
                      <h5 className="mb-1">{selectedAkademisyen.name}</h5>
                      <p className="text-muted mb-2">{selectedAkademisyen.unvan}</p>
                      <div className="badge bg-success-subtle text-success">
                        {selectedAkademisyen.performansOzeti}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <h6 className="section-title">{selectedAkademisyen.projeData.title}</h6>
                    <DataTable 
                      data={selectedAkademisyen.projeData.data}
                      onNoteClick={handleNoteClick}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="chart-container">
                      <HighchartsReact 
                        highcharts={Highcharts} 
                        options={getChartOptions("Proje Performans Trendi", selectedAkademisyen.projeData.data)} 
                      />
                    </div>
                  </div>
                </div>

                <div className="proje-listesi">
                  <h6 className="section-title mb-3">Projeler</h6>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Başlık</th>
                          <th>Tür</th>
                          <th>Yıl</th>
                          <th>Bütçe</th>
                          <th>Durum</th>
                          <th>Rol</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedAkademisyen.projeler.map((proje, index) => (
                          <tr key={index}>
                            <td>{proje.baslik}</td>
                            <td>
                              <span className={`badge bg-${proje.tur === 'TÜBİTAK' ? 'primary' : 'success'}-subtle text-${proje.tur === 'TÜBİTAK' ? 'primary' : 'success'}`}>
                                {proje.tur}
                              </span>
                            </td>
                            <td>{proje.yil}</td>
                            <td>{proje.butce}</td>
                            <td>
                              <span className={`badge bg-${proje.durum === 'Devam Ediyor' ? 'warning' : 'success'}-subtle text-${proje.durum === 'Devam Ediyor' ? 'warning' : 'success'}`}>
                                {proje.durum}
                              </span>
                            </td>
                            <td>{proje.rol}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        if (selectedBolum) {
          return (
            <div className="department-card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                  <button className="btn btn-link text-primary p-0 me-3" onClick={handleBack}>
                    <i className="fas fa-arrow-left"></i> Geri
                  </button>
                  <h5 className="card-title d-inline-block mb-0">{selectedBolum.bolumOzeti.title}</h5>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h6 className="section-title mb-4">Akademisyenler</h6>
                    <div className="akademisyen-list">
                      {selectedBolum.akademisyenler.map((akademisyen) => (
                        <div key={akademisyen.id} className="akademisyen-card" onClick={() => handleAkademisyenDetay(akademisyen)}>
                          <div className="akademisyen-info">
                            <div className="akademisyen-avatar">
                              {akademisyen.name.charAt(0)}
                            </div>
                            <div>
                              <h6 className="akademisyen-name">{akademisyen.name}</h6>
                              <p className="akademisyen-title">{akademisyen.unvan}</p>
                            </div>
                          </div>
                          <div className="performance-summary">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <span className="text-muted">Performans</span>
                              <span className="badge bg-success-subtle text-success">
                                {akademisyen.performansOzeti}
                              </span>
                            </div>
                            <div className="progress" style={{height: '6px'}}>
                              <div 
                                className="progress-bar bg-success" 
                                style={{width: akademisyen.performansOzeti.replace(/[^0-9]/g, '') + '%'}}
                              ></div>
                            </div>
                          </div>
                          <div className="mini-chart-container mt-3">
                            <HighchartsReact 
                              highcharts={Highcharts} 
                              options={getMiniChartOptions(akademisyen.mrData.data)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="col-md-6">
                    <h6 className="section-title mb-4">Performans Özeti</h6>
                    <div className="chart-container">
                      <HighchartsReact 
                        highcharts={Highcharts} 
                        options={getChartOptions("Bölüm Performans Trendi", selectedBolum.bolumOzeti.data)} 
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        let filteredProjeBolumleri = [...akademisyenProjeData.bolumler];
        if (selectedFaculties.length > 0 && !selectedFaculties.some(f => f.value === 'all')) {
          filteredProjeBolumleri = filteredProjeBolumleri.filter(bolum => {
            const faculty = getFacultyFromDepartment(bolum.bolumAdi);
            return selectedFaculties.some(f => f.value === faculty);
          });
        }
        if (selectedDepartments.length > 0 && !selectedDepartments.some(d => d.value === 'all')) {
          filteredProjeBolumleri = filteredProjeBolumleri.filter(bolum =>
            selectedDepartments.some(d => d.label === bolum.bolumAdi)
          );
        }
        if (searchTerm) {
          filteredProjeBolumleri = filteredProjeBolumleri.filter(bolum =>
            bolum.bolumAdi.toLowerCase().includes(searchTerm.toLowerCase())
          );
        }

        if (filteredProjeBolumleri.length === 0) {
          return <NoDataFound />;
        }

        return (
          <div className="department-card">
            <div className="card-header">
              <h5 className="card-title">Akademik Bölümler</h5>
            </div>
            <div className="card-body">
              <div className="row g-4">
                {filteredProjeBolumleri.map((bolum) => (
                  <div key={bolum.id} className="col-md-6">
                    <div className="bolum-card p-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="bolum-title mb-0">{bolum.bolumAdi}</h6>
                        <span className="badge bg-primary-subtle text-primary">
                          {bolum.performansOzeti}
                        </span>
                      </div>
                      
                      <div className="stats-grid">
                        <div className="stat-item">
                          <div className="stat-label">Akademisyen</div>
                          <div className="stat-value">{bolum.toplamAkademisyen}</div>
                        </div>
                        <div className="stat-item">
                          <div className="stat-label">Proje</div>
                          <div className="stat-value">{bolum.toplamProje}</div>
                        </div>
                        <div className="stat-item">
                          <div className="stat-label">Toplam Bütçe</div>
                          <div className="stat-value">{bolum.toplamButce}</div>
                        </div>
                        <div className="stat-item">
                          <div className="stat-label">Proje Ort.</div>
                          <div className="stat-value">{bolum.projeOrtalama}</div>
                        </div>
                      </div>

                      <button 
                        className="btn-detail"
                        // onClick={() => handleBolumDetay(bolum.id)}
                      >
                        Detayları Görüntüle
                        <i className="fas fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  const getHeatmapOptions = (type) => {
    const data = type === 'mr' ? [
      { name: 'Robotik ve Otonom Sistemleri', value: 1.35 },
      { name: 'Metalurji ve Malzeme Müh.', value: 2.59 },
      { name: 'Yapay Zeka ve Veri Müh.', value: 1.45 },
      { name: 'Şehir ve Bölge Planlama', value: 0.9 },
      { name: 'Mimarlık', value: 0.83 },
      { name: 'Fizik Mühendisliği', value: 1.22 }
    ] : [
      { name: 'Robotik ve Otonom Sistemleri', value: 85 },
      { name: 'Metalurji ve Malzeme Müh.', value: 92 },
      { name: 'Yapay Zeka ve Veri Müh.', value: 88 },
      { name: 'Şehir ve Bölge Planlama', value: 75 },
      { name: 'Mimarlık', value: 70 },
      { name: 'Fizik Mühendisliği', value: 82 }
    ];

    return {
      chart: {
        type: 'treemap',
        height: '80%',
        backgroundColor: '#f8fafc',
        style: {
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
        }
      },
      title: {
        text: type === 'mr' ? 'Öğretim Üyesi Başına M-R Bölümler' : 'Q1 + Q2 Yüzdesi Bölümler',
        align: 'left',
        style: {
          fontSize: '18px',
          fontWeight: '600',
          color: '#1e293b'
        }
      },
      subtitle: {
        text: type === 'mr' ? 'Bölümlere göre M-R sayıları karşılaştırması' : 'Bölümlere göre Q1+Q2 yüzdeleri karşılaştırması',
        align: 'left',
        style: {
          color: '#64748b',
          fontSize: '14px'
        }
      },
      series: [{
        layoutAlgorithm: 'squarified',
        data: data,
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b><br>{point.value:,.2f}' + (type === 'mr' ? '' : '%'),
          style: {
            fontSize: '13px',
            textOutline: 'none',
            color: '#ffffff'
          }
        },
        borderWidth: 3,
        borderColor: '#ffffff',
        levels: [{
          level: 1,
          layoutAlgorithm: 'squarified',
          dataLabels: {
            enabled: true
          }
        }]
      }],
      tooltip: {
        useHTML: true,
        backgroundColor: 'rgba(255, 255, 255, 0.96)',
        borderWidth: 0,
        borderRadius: 8,
        shadow: true,
        padding: 12,
        style: {
          fontSize: '13px'
        },
        formatter: function() {
          return '<div style="min-width: 150px;">' +
                 '<div style="font-weight: 600; margin-bottom: 5px; color: #1e293b;">' + 
                 this.point.name + '</div>' +
                 '<div style="display: flex; justify-content: space-between; color: #64748b;">' +
                 '<span>' + (type === 'mr' ? 'M-R Sayısı' : 'Q1+Q2 Yüzdesi') + ':</span>' +
                 '<span style="font-weight: 600; color: ' + 
                 (type === 'mr' ? '#1a73e8' : '#137333') + '">' +
                 this.point.value.toFixed(2) + (type === 'mr' ? '' : '%') + '</span>' +
                 '</div></div>';
        }
      },
      colorAxis: {
        minColor: type === 'mr' ? '#4285f4' : '#34a853',
        maxColor: type === 'mr' ? '#1a73e8' : '#137333'
      },
      credits: {
        enabled: false
      }
    };
  };

  const getMiniChartOptions = (data) => ({
    chart: {
      type: 'column',
      height: 100,
      backgroundColor: 'transparent',
      margin: [5, 0, 20, 0]
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: data.map(item => item.donem),
      labels: {
        style: {
          fontSize: '10px',
          color: '#64748b'
        }
      },
      lineWidth: 0,
      tickWidth: 0
    },
    yAxis: {
      title: {
        text: ''
      },
      labels: {
        enabled: false
      },
      gridLineWidth: 0
    },
    legend: {
      enabled: false
    },
    tooltip: {
      shared: true,
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderWidth: 0,
      shadow: true,
      useHTML: true,
      formatter: function() {
        return `<div style="padding: 8px;">
          <div style="font-weight: 600; margin-bottom: 4px;">${this.x}</div>
          <div style="color: #4f46e5;">Hedef: ${this.points[0].point.hedef}</div>
          <div style="color: #10b981;">Gerçekleşen: ${this.points[0].point.gerceklesen}</div>
        </div>`;
      }
    },
    plotOptions: {
      column: {
        grouping: false,
        borderRadius: 4
      },
      series: {
        pointPadding: 0.1,
        groupPadding: 0
      }
    },
    series: [
      {
        name: 'Hedef',
        data: data.map(item => ({
          y: typeof item.hedef === 'number' ? item.hedef : 0,
          hedef: item.hedef,
          gerceklesen: item.gerceklesen
        })),
        color: 'rgba(79, 70, 229, 0.2)'
      },
      {
        name: 'Gerçekleşen',
        data: data.map(item => ({
          y: item.gerceklesen === 'Henüz Girilmedi' || item.gerceklesen === 'Girilmedi' ? 0 : item.gerceklesen,
          hedef: item.hedef,
          gerceklesen: item.gerceklesen
        })),
        color: '#10b981'
      }
    ]
  });

  return (
    <div className='wrapper'>
      <PageHeader 
        title="Hedefler-Karşılaştır"
        description="Akademik performans göstergeleri ve istatistikler"
        breadcrumbs={[
          { text: 'Ana Sayfa', href: '/' },
          { text: 'Hedefler', href: '/hedefler' },
          { text: 'Hedefler-Karşılaştır' }
        ]}
      />

      <FilterCard>
        <FilterCard.Row className="text-end">
          <FilterCard.Col className="">
            <div className="action-buttons justify-content-end">
              <button
                className="btn-chart btn-chart-mr"
                onClick={() => {
                  setActiveHeatmapType('mr');
                  setHeatmapModalOpen(true);
                }}
              >
                <HiOutlineChartBar size={20} />
                M-R Karşılaştırma
              </button>
              <button
                className="btn-chart btn-chart-q1q2"
                onClick={() => {
                  setActiveHeatmapType('q1q2');
                  setHeatmapModalOpen(true);
                }}
              >
                <HiOutlineChartPie size={20} />
                Q1+Q2 Karşılaştırma
              </button>
            </div>
          </FilterCard.Col>
        </FilterCard.Row>
        <FilterCard.Row className="">
          <FilterCard.Col className="col-md-4">
            <div className="filter-select">
              <label className="select-label">Fakülte</label>
              <Select
                options={facultyOptions}
                value={selectedFaculties}
                onChange={handleFacultyChange}
                placeholder="Fakülte seçin..."
              />
            </div>
          </FilterCard.Col>
          <FilterCard.Col className="col-md-4">
            <div className="filter-select">
              <label className="select-label">Bölüm</label>
              <Select
                options={departmentOptions}
                value={selectedDepartments}
                onChange={handleDepartmentChange}
                placeholder="Bölüm seçin..."
              />
            </div>
          </FilterCard.Col>
        </FilterCard.Row>

        <FilterCard.Row>
          <FilterCard.Col className="searchCol">
            <FilterCard.SearchInput
              placeholder="Bölüm/Akademisyen ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </FilterCard.Col>
        </FilterCard.Row>
      </FilterCard>

      <div className="department-card">
        <div className="card-header main-header">
          <h5 className="card-title">
            {activeTab === 'birim-makale' && "Birim-Makale Karşılaştırması"}
            {activeTab === 'birim-proje' && "Birim-Proje Karşılaştırması"}
            {activeTab === 'akademisyen-makale' && "Akademisyen-Makale Karşılaştırması"}
            {activeTab === 'akademisyen-proje' && "Akademisyen-Proje Karşılaştırması"}
          </h5>
        </div>
        <div className="card-body">
          <Tabs activeTab={activeTab} onTabChange={setActiveTab}>
            <Tab id="birim-makale" title="Birim-Makale">
              {renderTabContent()}
            </Tab>
            <Tab id="birim-proje" title="Birim-Proje">
              {renderTabContent()}
            </Tab>
            <Tab id="akademisyen-makale" title="Akademisyen-Makale">
              {renderTabContent()}
            </Tab>
            <Tab id="akademisyen-proje" title="Akademisyen-Proje">
              {renderTabContent()}
            </Tab>
          </Tabs>
        </div>
      </div>

      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Not Detayı"
      >
        <div className="note-content">
          <div className="note-icon">
            <BsSearch size={24} className="text-primary" />
          </div>
          <p className="note-text">{selectedNote}</p>
        </div>
      </Modal>

      <Modal
        isOpen={heatmapModalOpen}
        onClose={() => setHeatmapModalOpen(false)}
        title={activeHeatmapType === 'mr' ? 'Öğretim Üyesi Başına M-R Bölümler' : 'Q1 + Q2 Yüzdesi Bölümler'}
      >
        <div style={{ height: '600px' }}>
          <HighchartsReact 
            highcharts={Highcharts} 
            options={getHeatmapOptions(activeHeatmapType)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default HedeflerKarsilastir; 